import Vue from 'vue';

Vue.filter('colones2', function (value) {
  value = Number(value);
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return '₡' + formatter.format(value);
})
